/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ExportChainReportsV2MutationRequest,
  ExportChainReportsV2MutationResponse,
  ExportChainReportsV2400,
  ExportChainReportsV2500,
} from '../types/ExportChainReportsV2'

function getExportChainReportsV2Url() {
  const res = {
    method: 'POST',
    url: `/api/v1/reports/chains/export/v2/` as const,
  }
  return res
}

/**
 * @description Start an async chain reports export.
 * @summary Start an async chain CRM reports export
 * {@link /api/v1/reports/chains/export/v2/}
 */
export async function exportChainReportsV2(
  data: ExportChainReportsV2MutationRequest,
  config: Partial<RequestConfig<ExportChainReportsV2MutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ExportChainReportsV2MutationResponse,
    ResponseErrorConfig<ExportChainReportsV2400 | ExportChainReportsV2500>,
    ExportChainReportsV2MutationRequest
  >({
    method: 'POST',
    url: getExportChainReportsV2Url().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
